export const BACKEND_URL: string = document.getElementById('backend-url')!.getAttribute('content')!;
export const BACKEND_V2_URL: string = document.getElementById('backend-v2-url')!.getAttribute('content')!;
export type APPLICATION_ENVIRONMENT = 'DEV' | 'PROD';
export const ENVIRONMENT: APPLICATION_ENVIRONMENT = document.getElementById('environment')!
    .getAttribute('content')! as unknown as APPLICATION_ENVIRONMENT;
